import { render, staticRenderFns } from "./AuditLogForUser.vue?vue&type=template&id=0b6e077d&scoped=true"
import script from "./AuditLogForUser.vue?vue&type=script&lang=js"
export * from "./AuditLogForUser.vue?vue&type=script&lang=js"
import style1 from "./AuditLogForUser.vue?vue&type=style&index=1&id=0b6e077d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6e077d",
  null
  
)

export default component.exports